// ============================================
// Authentication
// ============================================
export const authEndpoints = {
	login: "/api/auth/login",
	register: "/api/auth/register",
	logout: "/api/auth/logout",
	refresh: "/api/auth/refresh",
	me: "/api/auth/me",
} as const;

// ============================================
// Users
// ============================================
export const userEndpoints = {
	list: "/api/users",
	create: "/api/users",
	getById: "/api/users/:id",
	update: "/api/users/:id",
	delete: "/api/users/:id",
} as const;

// ============================================
// Organization Types
// ============================================
export const organizationTypeEndpoints = {
	list: "/api/organization-types",
	create: "/api/organization-types",
	getById: "/api/organization-types/:id",
	update: "/api/organization-types/:id",
	delete: "/api/organization-types/:id",
} as const;

// ============================================
// Organization Type Positions (Lavozimlar)
// ============================================
export const organizationTypePositionEndpoints = {
	list: "/api/organization-type-positions",
	create: "/api/organization-type-positions",
	getById: "/api/organization-type-positions/:id",
	update: "/api/organization-type-positions/:id",
	delete: "/api/organization-type-positions/:id",
} as const;

// ============================================
// Organizations (Tashkilotlar)
// RFC-002.1: GET /organizations/tree
// ============================================
export const organizationEndpoints = {
	list: "/api/organization",
	tree: "/api/organization/tree",
	treePicker: "/api/organization/tree-picker",
	create: "/api/organization",
	getById: "/api/organization/:id",
	update: "/api/organization/:id",
	delete: "/api/organization/:id",
	children: "/api/organization/:id/children",
	myChildren: "/api/organization/children",
	myChildrenCrossAccess: "/api/organization/children/cross-access",
} as const;

// ============================================
// Organization Cross Access (Tashkilotlararo kirish huquqlari)
// RFC-002.3: GET /organizations/cross-access (with accessType query)
// ============================================
export const crossAccessEndpoints = {
	list: "/api/organization-cross-access",
	create: "/api/organization-cross-access",
	getById: "/api/organization-cross-access/:id",
	update: "/api/organization-cross-access/:id",
	delete: "/api/organization-cross-access/:id",
} as const;

// ============================================
// SOATO (Hududlar)
// ============================================
export const soatoEndpoints = {
	list: "/api/soato",
} as const;

// ============================================
// Devices (Qurilmalar)
// RFC-009.1: GET /devices (organizationId, territoryId, status, direction, isActive)
// ============================================
export const deviceEndpoints = {
	list: "/api/devices",
	create: "/api/devices",
	getById: "/api/devices/:id",
	update: "/api/devices/:id",
	delete: "/api/devices/:id",
	sync: "/api/devices/:id/sync",
} as const;

// ============================================
// Staff (Xodimlar)
// RFC-003.1: GET /staff (page, limit, organizationId, brigadeId, search, type, isActive, sortBy, sortOrder)
// RFC-003.4: PUT /staff/:staffId/brigade
// ============================================
export const staffEndpoints = {
	list: "/api/staff",
	create: "/api/staff",
	getById: "/api/staff/:id",
	update: "/api/staff/:id",
	delete: "/api/staff/:id",
	assignBrigade: "/api/staff/:staffId/brigade",
} as const;

// ============================================
// Daily Attendance (Kunlik davomat)
// RFC-004.2: GET /attendance/daily
// ============================================
export const dailyAttendanceEndpoints = {
	list: "/api/daily-attendance",
	listByStaff: "/api/daily-attendance/by-staff",
	create: "/api/daily-attendance",
	getById: "/api/daily-attendance/:id",
	update: "/api/daily-attendance/:id",
	delete: "/api/daily-attendance/:id",
} as const;

// ============================================
// File Upload
// RFC-010.1: POST /files/upload
// RFC-010.2: GET /files/:fileId
// ============================================
export const fileEndpoints = {
	upload: "/api/file/upload",
	getById: "/api/file/:fileId",
} as const;

// ============================================
// Face Enrollment (Yuz ro'yxatga olish)
// ============================================
export const faceEnrollmentEndpoints = {
	list: "/api/face-enrollment",
	create: "/api/face-enrollment",
	getById: "/api/face-enrollment/:id",
	update: "/api/face-enrollment/:id",
	delete: "/api/face-enrollment/:id",
	sync: "/api/face-enrollment/sync",
	syncBulk: "/api/face-enrollment/sync/bulk",
} as const;

// ============================================
// GPS Devices (GPS qurilmalar)
// ============================================
export const gpsDevicesEndpoints = {
	list: "/api/gps-devices",
	getById: "/api/gps-devices/:id",
	create: "/api/gps-devices",
	update: "/api/gps-devices/:id",
	delete: "/api/gps-devices/:id",
} as const;

// ============================================
// Equipment (Texnikalar)
// ============================================
export const equipmentEndpoints = {
	list: "/api/equipment",
	create: "/api/equipment",
	getById: "/api/equipment/:id",
	update: "/api/equipment/:id",
	delete: "/api/equipment/:id",
	assignStaff: "/api/equipment/:id/staff",
	gpsHistory: "/api/equipment/:id/gps",
	live: "/api/equipment/live",
} as const;

// ============================================
// Equipment Types (Texnika turlari)
// ============================================
export const equipmentTypeEndpoints = {
	list: "/api/equipment-type",
	create: "/api/equipment-type",
	getById: "/api/equipment-type/:id",
	update: "/api/equipment-type/:id",
	delete: "/api/equipment-type/:id",
} as const;

// ============================================
// Staff Workday (Xodim ish kunlari)
// ============================================
export const staffWorkdayEndpoints = {
	list: "/api/staff-workday",
	create: "/api/staff-workday",
	getById: "/api/staff-workday/:id",
	update: "/api/staff-workday/:id",
	delete: "/api/staff-workday/:id",
} as const;

// ============================================
// Task Types (Topshiriq turlari)
// ============================================
export const taskTypeEndpoints = {
	list: "/api/task-types",
	create: "/api/task-types",
	getById: "/api/task-types/:id",
	update: "/api/task-types/:id",
	delete: "/api/task-types/:id",
} as const;

// ============================================
// Tasks (Topshiriqlar)
// ============================================
export const taskEndpoints = {
	list: "/api/tasks",
	create: "/api/tasks",
	getById: "/api/tasks/:id",
	update: "/api/tasks/:id",
	delete: "/api/tasks/:id",
	updateStatus: "/api/tasks/:id/status",
	addLocations: "/api/tasks/:id/locations",
	removeLocation: "/api/tasks/:id/locations/:locationId",
	addPlants: "/api/tasks/:id/plants",
	removePlant: "/api/tasks/:id/plants/:plantId",
	completeLocation: "/api/tasks/:id/locations/:locationId/complete",
	completePlant: "/api/tasks/:id/plants/:plantId/complete",
} as const;

// ============================================
// Task Schedule (Takrorlanish / cron)
// ============================================
export const taskScheduleEndpoints = {
	list: "/api/task-schedule",
	create: "/api/task-schedule",
	getById: "/api/task-schedule/:id",
	update: "/api/task-schedule/:id",
	delete: "/api/task-schedule/:id",
} as const;

// ============================================
// Territories (Hududlar)
// ============================================
export const territoryEndpoints = {
	list: "/api/territories",
	getById: "/api/territories/:territoryId",
	create: "/api/territories",
	update: "/api/territories/:territoryId",
	delete: "/api/territories/:territoryId",
	import: "/api/territories/import",
	importPreview: "/api/territories/import/preview",
	importConfirm: "/api/territories/import/confirm",
	assignStaff: "/api/territories/:territoryId/staff",
} as const;

// ============================================
// Brigades (Brigadalar)
// ============================================
export const brigadeEndpoints = {
	list: "/api/brigades",
	create: "/api/brigades",
	getById: "/api/brigades/:id",
	update: "/api/brigades/:id",
} as const;

// ============================================
// Plants (Ekinlar / o'simliklar)
// ============================================
export const plantsEndpoints = {
	list: "/api/plants",
	create: "/api/plants",
	getById: "/api/plants/:id",
	update: "/api/plants/:id",
	delete: "/api/plants/:id",
} as const;

// ============================================
// Plant Contracts (Ekin shartnomalari)
// ============================================
export const plantContractsEndpoints = {
	list: "/api/plant-contracts",
	create: "/api/plant-contracts",
	getById: "/api/plant-contracts/:id",
	update: "/api/plant-contracts/:id",
	delete: "/api/plant-contracts/:id",
} as const;

// ============================================
// Plantings (Ekishlar)
// ============================================
export const plantingsEndpoints = {
	list: "/api/plantings",
	create: "/api/plantings",
	getById: "/api/plantings/:id",
	update: "/api/plantings/:id",
	delete: "/api/plantings/:id",
	geojson: "/api/plantings/geojson",
} as const;

// ============================================
// Staff Location (Brigadir / xodim jonli joylashuvi)
// ============================================
export const staffLocationEndpoints = {
	live: "/api/staff-location/live",
	history: "/api/staff-location/:staffId/history",
} as const;

// ============================================
// Attendance Map (Davomat geo-nuqtalari)
// ============================================
export const attendanceMapEndpoints = {
	live: "/api/attendance-map/live",
} as const;

// ============================================
// Notifications (Bildirishnomalar)
// ============================================
export const notificationEndpoints = {
	list: "/api/notifications",
} as const;

// ============================================
// Reports (Hisobotlar)
// ============================================
export const reportsEndpoints = {
	attendance: "/api/reports/attendance",
	dashboard: "/api/reports/dashboard",
	brigadeRatings: "/api/reports/brigade-ratings",
} as const;

// ============================================
// Health Check
// ============================================
export const healthEndpoints = {
	check: "/api/health",
} as const;

// ============================================
// Type Definitions
// ============================================
export type AuthEndpoint = (typeof authEndpoints)[keyof typeof authEndpoints];
export type UserEndpoint = (typeof userEndpoints)[keyof typeof userEndpoints];
export type OrganizationTypeEndpoint =
	(typeof organizationTypeEndpoints)[keyof typeof organizationTypeEndpoints];
export type OrganizationTypePositionEndpoint =
	(typeof organizationTypePositionEndpoints)[keyof typeof organizationTypePositionEndpoints];
export type OrganizationEndpoint =
	(typeof organizationEndpoints)[keyof typeof organizationEndpoints];
export type CrossAccessEndpoint = (typeof crossAccessEndpoints)[keyof typeof crossAccessEndpoints];
export type DeviceEndpoint = (typeof deviceEndpoints)[keyof typeof deviceEndpoints];
export type StaffEndpoint = (typeof staffEndpoints)[keyof typeof staffEndpoints];
export type FaceEnrollmentEndpoint =
	(typeof faceEnrollmentEndpoints)[keyof typeof faceEnrollmentEndpoints];
export type SoatoEndpoint = (typeof soatoEndpoints)[keyof typeof soatoEndpoints];
export type FileEndpoint = (typeof fileEndpoints)[keyof typeof fileEndpoints];
export type HealthEndpoint = (typeof healthEndpoints)[keyof typeof healthEndpoints];

export type DailyAttendanceEndpoint =
	(typeof dailyAttendanceEndpoints)[keyof typeof dailyAttendanceEndpoints];
export type EquipmentEndpoint = (typeof equipmentEndpoints)[keyof typeof equipmentEndpoints];
export type EquipmentTypeEndpoint =
	(typeof equipmentTypeEndpoints)[keyof typeof equipmentTypeEndpoints];
export type StaffWorkdayEndpoint =
	(typeof staffWorkdayEndpoints)[keyof typeof staffWorkdayEndpoints];
export type TaskTypeEndpoint = (typeof taskTypeEndpoints)[keyof typeof taskTypeEndpoints];
export type TaskEndpoint = (typeof taskEndpoints)[keyof typeof taskEndpoints];
export type TaskScheduleEndpoint =
	(typeof taskScheduleEndpoints)[keyof typeof taskScheduleEndpoints];
export type TerritoryEndpoint = (typeof territoryEndpoints)[keyof typeof territoryEndpoints];
export type BrigadeEndpoint = (typeof brigadeEndpoints)[keyof typeof brigadeEndpoints];
export type PlantsEndpoint = (typeof plantsEndpoints)[keyof typeof plantsEndpoints];
export type PlantContractsEndpoint =
	(typeof plantContractsEndpoints)[keyof typeof plantContractsEndpoints];
export type PlantingsEndpoint = (typeof plantingsEndpoints)[keyof typeof plantingsEndpoints];
export type StaffLocationEndpoint =
	(typeof staffLocationEndpoints)[keyof typeof staffLocationEndpoints];
export type AttendanceMapEndpoint =
	(typeof attendanceMapEndpoints)[keyof typeof attendanceMapEndpoints];
export type NotificationEndpoint =
	(typeof notificationEndpoints)[keyof typeof notificationEndpoints];

export type ApiEndpoint =
	| AuthEndpoint
	| UserEndpoint
	| OrganizationTypeEndpoint
	| OrganizationTypePositionEndpoint
	| OrganizationEndpoint
	| CrossAccessEndpoint
	| DeviceEndpoint
	| StaffEndpoint
	| FaceEnrollmentEndpoint
	| SoatoEndpoint
	| FileEndpoint
	| HealthEndpoint
	| DailyAttendanceEndpoint
	| EquipmentEndpoint
	| EquipmentTypeEndpoint
	| TaskTypeEndpoint
	| TaskEndpoint
	| TaskScheduleEndpoint
	| TerritoryEndpoint
	| BrigadeEndpoint
	| StaffWorkdayEndpoint
	| PlantsEndpoint
	| PlantContractsEndpoint
	| PlantingsEndpoint
	| StaffLocationEndpoint
	| AttendanceMapEndpoint
	| NotificationEndpoint;

// ============================================
// Helper Functions
// ============================================

/**
 * Endpoint URL dagi path parametrlarini almashtirish
 * @example replaceParams("/api/users/:id", { id: "123" }) => "/api/users/123"
 */
export function replaceParams(endpoint: string, params: Record<string, string>): string {
	let url = endpoint;

	for (const [key, value] of Object.entries(params)) {
		url = url.replace(`:${key}`, encodeURIComponent(value));
	}

	return url;
}
